module.exports = __webpack_public_path__ + "static/assets/8997b5c23c84a4182883356bf17aae34.png";